import React from 'react'

import styles from './lineLoader.module.scss'

type Props = {
  className?: string
  fixed?: boolean
}

const LineLoader = ({ className = '', fixed = false }: Props) => (
  <div className={`${styles.container} ${fixed ? styles.fixed : ''} ${className}`}>
    <div className={styles.bar} />
  </div>
)

export default LineLoader
